import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { delay, select } from 'redux-saga/effects'

const PROJECT_WAIT_TRIES = 40
const PROJECT_WAIT_INTERVAL_MS = 500

// Экшены коллбэка диспатчит хук useGa4Callback при загрузке страницы —
// раньше, чем менеджер положит проект в стор, поэтому projectId приходится
// дождаться. Припаркованный грант живёт 10 минут, 20 секунд ожидания — с
// запасом.
export function* waitForProjectId() {
  for (let attempt = 0; attempt < PROJECT_WAIT_TRIES; attempt++) {
    const projectId: ID | null = yield select(
      migrationProjectSelector.getProjectId
    )

    if (projectId !== null) {
      return projectId
    }

    yield delay(PROJECT_WAIT_INTERVAL_MS)
  }

  return null
}
